import { render } from "./RestaurantReviewsModal.vue?vue&type=template&id=6bcdd790&scoped=true"
import script from "./RestaurantReviewsModal.vue?vue&type=script&lang=js"
export * from "./RestaurantReviewsModal.vue?vue&type=script&lang=js"

import "./RestaurantReviewsModal.vue?vue&type=style&index=0&id=6bcdd790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcdd790"]])

export default __exports__